import {
  Zap,
  Shield,
  Globe,
  Cpu,
} from "lucide-react";

const benefits = [
  {
    icon: Zap,
    title: "Fast Learning",
  },
  {
    icon: Cpu,
    title: "AI Powered",
  },
  {
    icon: Shield,
    title: "Enterprise Security",
  },
  {
    icon: Globe,
    title: "Accessible Anywhere",
  },
];

export default function Benefits() {
  return (
    <section className="bg-slate-950 py-28">

      <div className="container mx-auto px-6">

        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-8">

          {benefits.map((item) => {

            const Icon = item.icon;

            return (

              <div
                key={item.title}
                className="rounded-2xl bg-slate-900 border border-white/10 p-8 text-center"
              >

                <div className="w-16 h-16 mx-auto rounded-2xl bg-cyan-500/10 flex justify-center items-center text-cyan-400">

                  <Icon size={30} />

                </div>

                <h3 className="text-white font-semibold mt-6">

                  {item.title}

                </h3>

              </div>

            );
          })}

        </div>

      </div>

    </section>
  );
}